export default __webpack_public_path__ + "static/media/linkedin.30dee4a9.png";